import { NUMBER } from "../../constants/app-constants";

export default (inputValue = "") => {
    return inputValue.replace(/\s/g, "")
        .split("")
        .map((char, index) => (index === NUMBER.ONE || index === NUMBER.THREE) ? `${char} ` : char)
        .join("")
        .trim();
};
